import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bookmark-card',
  templateUrl: './bookmark-card.component.html',
  styleUrls: ['./bookmark-card.component.css']
})
export class BookmarkCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
